<template>
  <div class="container-fluid">
    <div class="row">
      <search-audit-log class="search" />
      <vue-good-table
        class="vue-table"
        :columns="columns"
        :rows="data"
        styleClass="vgt-table condensed bordered"
        :search-options="{ enabled: false }"
        :pagination-options="{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          perPageDropdown: [5, 10, 20, 30],
          dropdownAllowAll: false,
          allLabel: 'All',
        }"
      >
      </vue-good-table>
    </div>
  </div>
</template>

<script setup lang="ts">
import SearchAuditLog from "@/components/AuditLog/SearchAuditLog.vue";

const data = [
  {
    user: "userName1",
    uuid: "96b332ea-0405-11ed-b939-0242ac120002",
    action: "Download",
    dateTime: "2019-05-27T13:56:29Z",
  },
  {
    user: "userName2",
    uuid: "96b3357e-0405-11ed-b939-0242ac120002",
    action: "Download",
    dateTime: "2019-06-25T17:32:59Z",
  },
  {
    user: "userName3",
    uuid: "96b336b4-0405-11ed-b939-0242ac120002",
    action: "Delete",
    dateTime: "2019-10-21T13:28:06Z",
  },
  {
    user: "userName4",
    uuid: "96b337cc-0405-11ed-b939-0242ac120002",
    action: "Delete",
    dateTime: "2019-11-15T12:16:23Z",
  },
];

const columns = [
  {
    label: "User",
    field: "user",
    sortable: false,
  },
  {
    label: "DIP UUID",
    field: "uuid",
    sortable: false,
  },
  {
    label: "Audit Event Type",
    field: "action",
    sortable: false,
  },
  {
    label: "Datetime",
    field: "dateTime",
    type: "date",
    dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss'Z'",
    dateOutputFormat: "dd MMM yyyy HH:mm:ss",
    sortable: false,
  },
];
</script>

<style scoped>
.search {
  padding: 16px;
  position: fixed;
  z-index: 1;
  background: #fff;
}
.vue-table {
  position: relative;
  top: 86px;
}
</style>
